import { createAxiosInstance, guid, transformParameterData } from '../utils/helpers'
import { API_URL } from './index'
import * as types from './types'
import { displayMessages } from './common'

export function getParametros(id = null) {
	return dispatch => {
		const axios = createAxiosInstance()
		let queryString = ''
		if (id) queryString = `?id=${id}`
		axios.get(`${API_URL}/parametros${queryString}`)
		.then((res) => {
			const data = res.data.map(x => {
				const param = transformParameterData(x)
				delete param.parametro.parametro_cols
				delete param.parametro.parametro_rows
				return param
			})
			let fn1
			if (id) {
				fn1 = d => d({ type: types.OBTENER_PARAMETRO, payload: { id, data } })
			} else {
				fn1 = d => d({ type: types.OBTENER_PARAMETROS, payload: data })
			}
			fn1(dispatch)
		})
		.catch((err) => {
			console.log(err)
			displayMessages(dispatch, err)
		})
	}
}

export function updateInputs(path, value) {
	return (dispatch) => {
		dispatch({ type: types.MODIFICAR_INPUTS_PARAMETROS, payload: { path, value } })
	}
}

export function addNewParameterDetail(parametroId) {
	return (dispatch) => {
		dispatch({ type: types.ADICIONAR_NUEVO_DETALLE_PARAMETRO, payload: { parametroId } })
	}
}

export function createOrUpdateParametros () {
	const axios = createAxiosInstance()
	return (dispatch, getState) => {
		const parametros = getState().parametros1.get('parametros')
		const toSave = []
		parametros.forEach(x => {
			x.get('data').forEach(d => {
				x.get('columnas').forEach(c => {
					if (d.getIn([c.get('value'), 'updated'])) {
						const detParam = d.get(c.get('value')).toJS()
						detParam.registro = d.get('registro')
						toSave.push(detParam)
					}
				})
			})
		})

		if (toSave.length > 0) {
			axios.post(`${API_URL}/parametros`, toSave)
				.then(res => {
					const fn0 = (d) => d(getParametros())
					fn0(dispatch)
					displayMessages(dispatch, { success: 'Los parametros ha sido actualizados exitosamente' })
				})
				.catch(err => {
					console.log(err)
					displayMessages(dispatch, err)
				})
		} else {
			displayMessages(dispatch, { info: 'No se encontraron cambios para guardar' })
		}
	}
}

export function toggleSelectAllItems(parametroIndex, checked) {
	return (dispatch) => {
		dispatch({ type: types.CONMUTAR_SELECCION_TODOS_PARAMETROS, payload: { parametroIndex, checked } })
	}
}

export function deleteParametros(parametroIndex) {
	const axios = createAxiosInstance()
	return (dispatch, getState) => {
		const parametro = getState().parametros1.getIn(['parametros', parametroIndex])
		const toDelete = []
		const selected = parametro.get('data').filter(x => x.get('selected'))

		const fns = []
		selected.forEach(x => {
			parametro.get('columnas').forEach(c => {
				const id = x.getIn([c.get('value'), 'id'])
				if (id) {
					const fn = () => axios.delete(`${API_URL}/parametros/${id}`)
					fns.push(fn)
				}
			})
		})

		const toResultObject = (promise) => {
			return promise
			.then(result => ({ success: true, result }))
			.catch(error => ({ success: false, error }));
		}

		Promise.all(fns.map(x => x()).map(toResultObject))
		.then(res => {
			const succeded = []
			const failed = []
			res.forEach(x => {
				if (!x.success) {
					failed.push(x.error.response.data.ExceptionMessage)
				} else {
					succeded.push(x.result.data.Nombre)
				}
			})
			if (succeded.length > 0) displayMessages(dispatch, { success: 'Se han eliminado los siguentes parametros: ' + succeded.join(', ') })
			if (failed.length > 0) displayMessages(dispatch, { response: { status: 500, data: failed.join('\n') } })
			dispatch(getParametros(parametro.get('Id')))
			dispatch(showHideModalDelete(false))
		})
	}
}

export function showHideModalDelete(open, message = null, action = null) {
	return (dispatch) => {
		dispatch({ type: types.MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_PARAMETRO, payload: { open, message, action } })
	}
}



// WEBPACK FOOTER //
// ./src/actions/parametros1.js